import type { MigrationTranslation } from './en';

/** Arabic (Modern Standard). Pending review by native speakers, as the note in the interface says. */
export const migrationAr: MigrationTranslation = {
  nav: 'استيراد السجل',
  title: 'الاستيراد من أداة أخرى',
  description: 'انقل محادثات الدعم السابقة إلى Hamnivo. لا يتغير شيء في الأداة التي تستخدمها الآن.',
  newImport: 'استيراد جديد',
  exportHistory: 'تصدير السجل',
  loading: 'جارٍ تحميل عمليات الاستيراد',
  noBrands: 'أضف علامة تجارية واربطها بـ Chatwoot قبل الاستيراد.',
  list: {
    title: 'عمليات الاستيراد والتصدير',
    empty: {
      title: 'لا توجد عمليات استيراد بعد',
      description:
        'ارفع ملف تصدير من tawk.to أو Zendesk أو Intercom أو Hamnivo، أو اربط حساب Chatwoot آخر. سترى محتواه قبل استيراد أي شيء.',
    },
    columns: {
      file: 'الملف',
      kind: 'النوع',
      brand: 'العلامة التجارية',
      state: 'الحالة',
      conversations: 'المحادثات',
      started: 'بدأ',
    },
    open: 'فتح {{name}}',
    importKind: 'استيراد من {{source}}',
    exportKind: 'تصدير',
    of: '{{done}} من {{total}}',
  },
  back: 'كل عمليات الاستيراد',
  steps: {
    label: 'خطوات الاستيراد',
    source: 'المصدر',
    sourceHint: 'ملف التصدير',
    check: 'الفحص',
    checkHint: 'الحقول والإعدادات',
    sample: 'مراجعة عينة',
    sampleHint: 'تحقّق وأكّد',
    import: 'الاستيراد',
    importHint: 'التشغيل والمتابعة',
    done: 'تمّت',
    current: 'الخطوة الحالية',
  },
  sources: {
    'tawk.to': 'tawk.to',
    hamnivo: 'حزمة Hamnivo',
    chatwoot: 'Chatwoot',
    intercom: 'Intercom',
    zendesk: 'Zendesk',
  },
  state: {
    scanning: 'جارٍ فحص الملف',
    rejected: 'رُفض الملف',
    blocked: 'يحتاج إلى انتباه',
    ready: 'تم الفحص',
    dry_running: 'جارٍ العدّ',
    dry_run_ready: 'جاهز للاستيراد',
    queued: 'بانتظار البدء',
    running: 'جارٍ الاستيراد',
    paused: 'متوقف مؤقتًا',
    cancelled: 'أُلغي',
    completed: 'انتهى',
    failed: 'توقف',
    rolling_back: 'جارٍ الحذف',
    rolled_back: 'حُذف',
    closed: 'تمت الموافقة',
  },
  upload: {
    title: 'بدء استيراد',
    description: 'اختر مصدر ملف التصدير وارفعه. لن يُستورد شيء بعد.',
    brand: 'الاستيراد إلى العلامة التجارية',
    brandRequired: 'اختر علامة تجارية.',
    source: 'مصدر ملف التصدير',
    sourceHints: {
      'tawk.to': 'ملفات ZIP أو JSON من «تصدير المحادثات» في tawk.to.',
      zendesk:
        'ملف ZIP من تصدير JSON الكامل في Zendesk. أضف تصدير المستخدمين إلى ملف ZIP نفسه لاستيراد الأسماء.',
      intercom: 'المحادثات كما تعيدها واجهة Intercom البرمجية، في ملفات JSON أو NDJSON.',
      hamnivo: 'حزمة مُصدَّرة من Hamnivo أو مُعدّة بصيغة Hamnivo.',
      chatwoot: 'حساب Chatwoot آخر، يُقرأ برمز وصول أحد مستخدميه.',
    },
    file: 'ملف التصدير',
    fileHint: 'ZIP أو JSON أو NDJSON، حتى 20 ميغابايت. يُفحص بحثًا عن البرمجيات الضارة قبل قراءته.',
    fileChosen: 'تم اختيار: {{name}} ({{size}})',
    fileRequired: 'اختر ملف التصدير.',
    fileType: 'اختر ملف ZIP أو JSON أو NDJSON.',
    fileTooLarge: 'حجم هذا الملف {{size}}. الحد الأقصى لملف التصدير 20 ميغابايت.',
    chatwoot: {
      url: 'عنوان Chatwoot',
      urlHint: 'مثلًا https://chat.example.com',
      urlRequired: 'أدخل عنوان Chatwoot الذي تستورد منه.',
      account: 'معرّف الحساب',
      accountHint: 'الرقم بعد ‎/accounts/‎ في شريط عنوان Chatwoot ذاك.',
      accountInvalid: 'أدخل رقم الحساب.',
      token: 'رمز الوصول',
      tokenHint:
        'من إعدادات الملف الشخصي في Chatwoot ذاك. رمز المسؤول يقرأ كل الصناديق. يُستخدم مرة واحدة ثم يُحذف.',
      tokenRequired: 'أدخل رمز الوصول.',
      inboxes: 'معرّفات الصناديق',
      inboxesHint: 'هذه الصناديق فقط، مفصولة بفواصل. اتركه فارغًا للكل.',
      inboxesInvalid: 'استخدم أرقام الصناديق مفصولة بفواصل.',
      submit: 'اتصل وافحص',
    },
    privacy:
      'لا يرى الملف إلا من يدير عمليات الاستيراد لهذه العلامة التجارية. يُحذف بعد الموافقة على الاستيراد أو حذفه.',
    submit: 'رفع وفحص',
    uploaded: 'تم رفع {{name}}. جارٍ فحصه الآن.',
  },
  file: {
    uploaded: 'رُفع {{time}} · {{size}}',
    read: 'قُرئ {{time}} · {{size}}',
    into: 'إلى {{brand}}',
    purged: 'حُذف الملف نفسه. تبقى الأعداد والتقارير.',
    change: 'رفع ملف آخر',
  },
  scanning: {
    title: 'جارٍ فحص الملف',
    description: 'نفحصه بحثًا عن البرمجيات الضارة ونقرؤه. لم يُستورد شيء بعد.',
    apiTitle: 'جارٍ القراءة من Chatwoot',
    apiDescription:
      'نقرأ المحادثات والملفات، ثم نفحصها بحثًا عن البرمجيات الضارة. لم يُستورد شيء بعد.',
  },
  rejected: {
    title: 'لا يمكن استيراد هذا الملف',
    reasons: {
      malware: 'وجد فاحص البرمجيات الضارة تهديدًا في هذا الملف. حُذف الملف.',
      scan_unavailable: 'تعذّر على فاحص البرمجيات الضارة فحص الملف. حاول مرة أخرى بعد بضع دقائق.',
      not_supported: 'هذا ليس ملف تصدير يمكننا قراءته. اختر ملف التصدير بصيغة ZIP أو JSON.',
      truncated: 'ينتهي الملف قبل أوانه. ربما لم يكتمل تنزيله. نزّل ملف التصدير مرة أخرى.',
      corrupt: 'الملف تالف ولا يمكن قراءته. نزّل ملف التصدير مرة أخرى.',
      too_large: 'يتوسع الملف إلى أكثر مما نقبل. قسّم التصدير إلى ملفات أصغر.',
      too_many_files: 'يحتوي الأرشيف على ملفات كثيرة جدًا. قسّم التصدير إلى ملفات أصغر.',
      unsafe_path: 'يحتوي الأرشيف على اسم ملف غير آمن.',
      not_utf8: 'الملف ليس نصًا بترميز UTF-8.',
      source_denied:
        'لا يستطيع الرمز قراءة هذا الحساب. تحقّق من معرّف الحساب، واستخدم رمز أحد مسؤوليه.',
      source_unreachable: 'تعذّر الوصول إلى Chatwoot ذاك. تحقّق من العنوان وحاول مرة أخرى.',
      private_address: 'هذا العنوان داخل شبكة خاصة لا يصل إليها الاستيراد.',
      insecure_url: 'يجب أن يبدأ العنوان بـ https://.',
      invalid_url: 'هذا العنوان غير صالح.',
      unresolved: 'تعذّر العثور على هذا العنوان.',
      empty: 'الملف فارغ.',
      other: 'تعذّرت قراءة الملف.',
    },
  },
  preflight: {
    title: 'محتوى ملف التصدير',
    description: 'أعداد وأسماء حقول فقط. لم يُستورد شيء.',
    counts: {
      conversations: 'المحادثات',
      messages: 'الرسائل',
      internalNotes: 'الملاحظات الداخلية',
      contacts: 'الأشخاص',
      attachments: 'الملفات',
      attachmentFiles: 'الملفات المضمّنة',
    },
    declared: 'يذكر ملف التصدير أنه يحتوي على {{conversations}} محادثة و{{messages}} رسالة.',
    truncated: 'جزء من ملف التصدير مفقود',
    truncatedHint:
      'بعض المحادثات غير مكتملة في هذا التصدير، وهي مذكورة أدناه. يمكنك استيراد الموجود، أو التصدير مرة أخرى أولًا.',
    detected: 'يبدو هذا الملف تصديرًا من {{source}}. ابدأ من جديد واختر {{source}}.',
    checks: {
      title: 'قبل الاستيراد',
      status: { ok: 'جاهز', warning: 'تحقّق', blocked: 'محظور' },
      codes: {
        authority_connected: {
          ok: 'Chatwoot مرتبط بهذه العلامة التجارية.',
          blocked: 'اربط هذه العلامة التجارية بـ Chatwoot أولًا (العلامات التجارية والتثبيت).',
        },
        import_inbox: {
          ok: 'تذهب المحادثات المستوردة إلى صندوق خاص بها، دون ردود أو روبوتات أو إسناد أو استبيانات.',
          will_create:
            'يُنشأ صندوق للمحادثات المستوردة عند أول استيراد. لا يرد أبدًا ولا يُسند ولا يرسل استبيانات.',
          blocked:
            'في صندوق المحادثات المستوردة إعدادات قد ترسل إشعارات للناس: {{detail}}. أوقفها في Chatwoot ثم افحص مرة أخرى.',
        },
        authority_admin: {
          ok: 'يستطيع Hamnivo قراءة إعدادات Chatwoot التي يحتاج إلى فحصها.',
          blocked:
            'لا يستطيع Hamnivo قراءة إعدادات Chatwoot. أعد ربط Chatwoot بهذه العلامة التجارية.',
        },
        automations: {
          ok: 'لا توجد أتمتة في Chatwoot تعمل على المحادثات المستوردة.',
          blocked:
            '{{detail}} من عمليات الأتمتة في Chatwoot ستعمل على المحادثات المستوردة. أوقفها أو استثنِ صندوق الاستيراد، ثم افحص مرة أخرى.',
        },
        integrations: {
          ok: 'لا يتلقى أي تكامل الرسائل المستوردة.',
          blocked: 'ستتلقى هذه التكاملات الرسائل المستوردة: {{detail}}. أوقفها ثم افحص مرة أخرى.',
        },
        authority_unreachable: {
          ok: 'يمكن الوصول إلى Chatwoot.',
          blocked: 'تعذّر الوصول إلى Chatwoot الآن. حاول مرة أخرى بعد بضع دقائق.',
        },
        source_access: {
          ok: 'يستطيع الرمز قراءة كل صناديق الحساب.',
          blocked: 'الرمز ليس لمسؤول: تُقرأ الصناديق التي يراها فقط.',
        },
        source_mismatch: {
          ok: 'الملف يطابق المصدر الذي اخترته.',
          blocked: 'الملف لا يطابق المصدر الذي اخترته.',
        },
      },
      settings: {
        webhook: 'Webhook',
        agent_bot: 'روبوت',
        auto_assignment: 'إسناد تلقائي',
        greeting: 'رسالة ترحيب',
        csat: 'استبيان رضا',
        working_hours: 'رسائل ساعات العمل',
        single_conversation: 'محادثة واحدة لكل شخص',
      },
    },
    fields: {
      title: 'الحقول',
      description: 'كيف يُستورد كل حقل في الملف. الحقول التي لا تُستورد مذكورة هنا، ولا تُحذف بصمت.',
      columns: {
        source: 'الحقل في الملف',
        target: 'يصبح',
        status: 'الحالة',
        found: 'موجود في',
      },
      status: {
        supported: 'يُستورد',
        transformed: 'يُعدَّل عند الاستيراد',
        unsupported: 'لا يُستورد',
      },
      required: 'مطلوب',
      records: '{{count}} سجل',
      showUnsupported: 'عرض {{fields}} حقلًا لا تُستورد',
      hideUnsupported: 'إخفاء الحقول التي لا تُستورد',
      same: 'يبقى كما هو',
      none: '—',
      targets: {
        'conversation.source_id': 'معرّف المحادثة',
        'conversation.kind': 'نوع المحادثة',
        'conversation.started_at': 'وقت البدء',
        'conversation.completeness_check': 'فحص الاكتمال',
        'conversation.attribute': 'تفصيل المحادثة',
        'message.original_time': 'الوقت الأصلي للرسالة',
        'message.text': 'نص الرسالة',
        'message.kind': 'نوع الرسالة',
        'message.author': 'المرسل',
        'message.author_name': 'اسم المرسل',
        'message.author_source_id': 'معرّف المرسل',
        'attachment.link': 'رابط الملف',
        'contact.source_id': 'معرّف الشخص',
        'contact.name': 'الاسم',
        'contact.unverified_email': 'البريد الإلكتروني، يُحفظ كغير موثّق',
        'contact.unverified_phone': 'الهاتف، يُحفظ كغير موثّق',
        'contact.location': 'الموقع',
        'conversation.status': 'الحالة',
        'conversation.labels': 'الوسوم',
        'conversation.assignee': 'المسؤول عنها',
        'conversation.team': 'الفريق',
        'message.visibility': 'خاصة أو عامة',
        'attachment.file': 'الملف',
        'contact.attribute': 'تفصيل الشخص',
        'contact.identifier': 'المعرّف',
        'conversation.subject': 'الموضوع',
        'conversation.channel': 'القناة',
        'message.source_id': 'معرّف الرسالة',
        'message.formatting': 'التنسيق',
      },
    },
    missing: {
      title: 'حقل مطلوب مفقود',
      description:
        'لا يحتوي ملف التصدير هذا على «{{field}}». لا يمكن استيراد المحادثات من دونه. صدّر مرة أخرى مع تضمينه.',
    },
    limits: {
      title: 'حدود معروفة في {{source}}',
      codes: {
        tawk_export_cap:
          'يصدّر tawk.to حتى 50 محادثة في كل مرة. صدّر كل فترة تحتاج إليها، واستورد كل ملف.',
        tawk_rest_approval:
          'الاستيراد مباشرة من واجهة tawk.to البرمجية يحتاج إلى موافقة من tawk.to، لذلك يعتمد الاستيراد على الملفات المُصدَّرة.',
        tawk_attachment_links:
          'تحتوي ملفات التصدير على روابط للملفات، لا على الملفات نفسها. تُذكر الملفات على أنها لم تُستورد.',
        tawk_tickets: 'لا تُستورد التذاكر والرسائل غير المتصلة.',
        tawk_no_notes: 'لا تحتوي ملفات تصدير tawk.to على ملاحظات داخلية.',
        tawk_unverified_email:
          'كتب الزوار عناوين البريد الإلكتروني بأنفسهم. تُحفظ للرجوع إليها ولا تُستخدم أبدًا لمطابقة الأشخاص.',
        chatwoot_snapshot_cap:
          'يقرأ الاستيراد الواحد عددًا محددًا من المحادثات، الأقدم أولًا. شغّله مرة أخرى للمتابعة: لا تُقرأ المحادثات المستوردة مرتين.',
        chatwoot_agent_scope: 'رمز الموظف يقرأ صناديق ذلك الموظف فقط.',
        chatwoot_activity: 'لا تُستورد رسائل النشاط (تغيّر الحالة، الإسناد).',
        chatwoot_unverified_contacts:
          'تُحفظ عناوين البريد وأرقام الهاتف كغير موثّقة، ولا يُطابَق بها الأشخاص أبدًا.',
        chatwoot_token_once:
          'يُستخدم الرمز مرة واحدة لقراءة الحساب ثم يُحذف من Hamnivo. ألغِه في Chatwoot بعد ذلك.',
        zendesk_large_tickets:
          'لا يصدّر Zendesk تعليقات التذاكر التي يزيد حجمها على 1 ميغابايت. تُذكر هذه التذاكر على أنها غير مكتملة ولا تُستورد.',
        zendesk_users_export:
          'أضف تصدير المستخدمين إلى ملف ZIP نفسه، فهو يعطي الأسماء ويميّز العملاء من أعضاء الفريق. بدونه لا تُستورد تعليقات الأشخاص غير المعروفين.',
        zendesk_attachment_links:
          'تحتوي ملفات التصدير على روابط للملفات، لا على الملفات نفسها. تُذكر الملفات على أنها لم تُستورد.',
        zendesk_history: 'لا يُستورد سجل التذكرة ولا المحادثات الجانبية ولا الحقول المخصصة.',
        zendesk_unverified_contacts:
          'تُحفظ عناوين البريد وأرقام الهاتف كغير موثّقة، ولا يُطابَق بها الأشخاص أبدًا.',
        intercom_api_format:
          'لا يوفّر Intercom ملف تصدير فيه نص الرسائل. ارفع المحادثات كما تعيدها واجهته البرمجية.',
        intercom_parts_cap:
          'تعيد واجهة Intercom البرمجية آخر 500 جزء من المحادثة على الأكثر. تُستورد المحادثات الأطول دون أقدم أجزائها، وتُذكر على أنها غير مكتملة.',
        intercom_events: 'لا تُستورد عمليات الإسناد وتغييرات الحالة والأحداث الأخرى.',
        intercom_plain_text: 'تُستورد الرسائل نصًا عاديًا، دون التنسيق والصور المضمّنة.',
        intercom_attachment_links:
          'تحتوي المحادثات على روابط للملفات، لا على الملفات نفسها. تُذكر الملفات على أنها لم تُستورد.',
        intercom_unverified_contacts:
          'تُحفظ عناوين البريد وأرقام الهاتف كغير موثّقة، ولا يُطابَق بها الأشخاص أبدًا.',
        package_links_only: 'لا تُستورد الملفات المذكورة كروابط فقط.',
      },
    },
    issues: {
      title: 'سجلات تحتاج إلى مراجعة',
      none: 'يمكن استيراد كل السجلات.',
      count: '{{count}} سجل',
      examples: 'مثلًا: {{ids}}',
      error: 'لا يمكن استيراده',
      warning: 'تحقّق',
    },
    recheck: 'افحص مرة أخرى',
    next: 'مراجعة عينة',
    blocking: 'أصلح البنود المعلّمة بـ «محظور»، ثم افحص مرة أخرى.',
    cancel: 'إلغاء الاستيراد',
    cancelTitle: 'إلغاء هذا الاستيراد؟',
    cancelBody: 'لم يُستورد شيء. يُحذف الملف المرفوع.',
    cancelled: 'أُلغي الاستيراد.',
  },
  reasons: {
    duplicate_existing: 'مستورد من قبل',
    duplicate_in_file: 'موجود في الملف أكثر من مرة',
    invalid_record: 'ليس سجلًا صالحًا',
    missing_time: 'لا وقت له',
    unsupported_type: 'النوع غير مدعوم',
    unsupported_sender: 'المرسل غير مدعوم',
    missing_conversation: 'محادثته مفقودة',
    missing_contact: 'الشخص المرتبط به مفقود',
    empty_message: 'لا شيء للاستيراد',
    missing_attachment: 'الملف مفقود من التصدير',
    binary_not_in_export: 'رابط فقط، والملف ليس في التصدير',
    checksum_mismatch: 'الملف تالف (المجموع الاختباري مختلف)',
    type_mismatch: 'نوع الملف غير مسموح أو ليس كما يدّعي',
    too_large: 'كبير جدًا',
    malware: 'وُجدت برمجيات ضارة',
    scan_unavailable: 'تعذّر فحصه',
    authority_rejected: 'رفضه Chatwoot',
    authority_unavailable: 'كان Chatwoot غير متاح',
    parent_failed: 'لم تُستورد محادثته',
    not_referenced: 'لا تستخدمه أي محادثة',
    cancelled: 'أُلغي الاستيراد قبله',
    truncated: 'ناقص في التصدير',
    invalid_json: 'سطر غير مقروء',
    truncated_file: 'ملف ناقص',
    count_mismatch: 'سجلات أقل مما يذكره الملف',
    export_cap_reached: 'ربما بلغ التصدير حد الخمسين محادثة',
    incomplete_package: 'تذكر الحزمة أنها غير مكتملة',
    no_conversations: 'لم تُعثر على محادثات',
    unknown_file: 'ملف غير معروف',
  },
  kinds: {
    conversation: 'المحادثات',
    message: 'الرسائل',
    note: 'الملاحظات الداخلية',
    contact: 'الأشخاص',
    attachment: 'الملفات',
  },
  kind: {
    conversation: 'محادثة',
    message: 'رسالة',
    contact: 'شخص',
    attachment: 'ملف',
  },
  dryRun: {
    title: 'نتائج العينة',
    description: 'ما سيفعله الاستيراد. لم يتغير شيء.',
    counting: 'جارٍ عدّ ما سيفعله الاستيراد…',
    ready: 'محادثة جاهزة',
    readyHint: 'ستُستورد هذه.',
    duplicates: 'مكررة',
    duplicatesHint: 'مستوردة من قبل. تُتخطّى.',
    review: 'تحتاج إلى مراجعة',
    reviewHint: 'بيانات مفقودة أو غير صالحة. تُذكر ولا تُستورد.',
    messages: '{{ready}} رسالة، منها {{internal}} ملاحظة داخلية.',
    people: '{{verified}} شخص بمعرّف موثّق، و{{unverified}} من دونه.',
    peopleHint: 'لا يُطابَق الأشخاص أبدًا بالبريد الإلكتروني أو الهاتف المكتوب يدويًا.',
    files: '{{ready}} ملف جاهز، و{{review}} تحتاج إلى مراجعة.',
    truncated: 'ملف التصدير هذا غير مكتمل. سيذكر التقرير ما هو مفقود.',
    duplicateChoice: 'التعامل مع المكررات',
    duplicateSkip: 'تخطّي الموجود',
    duplicateHint: 'تُتخطّى المحادثات المستوردة من قبل. تبقى الأصلية كما هي.',
    destination:
      'تُستورد المحادثات إلى {{brand}}. لا يراها إلا من لديه صلاحية الوصول إلى هذه العلامة التجارية.',
    nothingSent: 'لا يُرسل شيء إلى العملاء أو الزملاء أثناء الاستيراد.',
    report: 'تنزيل تقرير المراجعة',
    run: 'تشغيل الاستيراد',
    runTitle: 'استيراد {{count}} محادثة إلى {{brand}}؟',
    runBody:
      'تحتفظ المحادثات بأوقاتها الأصلية، وتبقى الملاحظات الداخلية خاصة. يمكنك الإيقاف المؤقت أو الإلغاء في أي وقت.',
    runSubmit: 'بدء الاستيراد',
    started: 'بدأ الاستيراد.',
    again: 'العدّ مرة أخرى',
  },
  sample: {
    title: 'محادثة نموذجية',
    description: 'محادثة واحدة من الملف كما ستظهر. عناوين البريد والأرقام مخفية.',
    choose: 'العينة',
    option: 'المحادثة {{number}}',
    loading: 'جارٍ تحميل العينة',
    source: 'في ملف التصدير',
    imported: 'في Hamnivo',
    notYet: 'لم تُستورد بعد.',
    started: 'بدأت {{time}}',
    internal: 'ملاحظة داخلية',
    authors: { customer: 'عميل', agent: 'زميل', bot: 'روبوت', system: 'النظام' },
    noText: 'لا يوجد نص',
    originalTime: 'الوقت الأصلي {{time}}',
    importedAt: 'استُوردت {{time}}',
    matches: 'تطابق ملف التصدير',
    differs: 'تختلف عن ملف التصدير',
    problems: {
      order_or_count: 'رسائل مفقودة أو بترتيب مختلف.',
      original_time: 'لرسالة وقت أصلي مختلف.',
      visibility: 'لرسالة ظهور مختلف.',
    },
    unavailable: 'العينات غير متاحة: حُذف ملف التصدير.',
  },
  progress: {
    title: 'تقدّم الاستيراد',
    queued: 'بانتظار البدء…',
    count: 'استُوردت {{done}} من {{total}} محادثة',
    percent: 'أُنجز {{percent}}',
    checkpoint: 'المحادثة {{done}} من {{total}}، حُفظت {{time}}',
    closeHint: 'يمكنك إغلاق هذه الصفحة. يستمر الاستيراد في الخلفية.',
    pausing: 'سيتوقف مؤقتًا عند نقطة الحفظ التالية…',
    cancelling: 'سيُلغى عند نقطة الحفظ التالية…',
    paused: 'متوقف مؤقتًا عند المحادثة {{done}} من {{total}}.',
    failed: 'توقف الاستيراد: {{reason}}. يتابع من نقطة الحفظ عند الاستئناف.',
    errors: {
      authority_unavailable: 'كان Chatwoot غير متاح',
      import_inbox_not_quiet: 'في صندوق الاستيراد إعدادات قد ترسل إشعارات للناس',
      internal: 'حدث خطأ من جهتنا',
      other: 'حدث خطأ',
    },
    pause: 'إيقاف مؤقت',
    resume: 'استئناف',
    cancel: 'إلغاء الاستيراد',
    cancelTitle: 'إلغاء هذا الاستيراد؟',
    cancelBody: 'يتوقف عند نقطة الحفظ التالية. تبقى المحادثات المستوردة حتى تحذفها.',
    pauseRequested: 'سيتوقف الاستيراد مؤقتًا عند نقطة الحفظ التالية.',
    resumed: 'استُؤنف الاستيراد.',
    cancelRequested: 'يتوقف الاستيراد عند نقطة الحفظ التالية.',
  },
  result: {
    completed: 'اكتمل الاستيراد',
    completedIssues: 'اكتمل الاستيراد مع بعض المشكلات',
    cancelled: 'أُلغي الاستيراد',
    rolledBack: 'حُذف الاستيراد',
    closed: 'تمت الموافقة على الاستيراد',
    finished: 'انتهى {{time}}',
    approved: 'تمت الموافقة {{time}}',
    imported: 'محادثة مستوردة',
    skipped: 'تم تخطيها (مكررة)',
    notImported: 'لم تُستورد',
    failed: 'فشلت',
    downloadErrors: 'تنزيل ما لم يُستورد',
    retry: 'إعادة محاولة السجلات الفاشلة',
    retryHint: 'تُرسل السجلات الفاشلة فقط مرة أخرى. لا تتكرر السجلات المستوردة أبدًا.',
    retried: 'جارٍ إعادة محاولة السجلات الفاشلة.',
  },
  review: {
    title: 'المطابقة',
    description: 'كل سجل في ملف التصدير، وما آل إليه.',
    columns: {
      kind: 'السجلات',
      discovered: 'في التصدير',
      imported: 'مستوردة',
      skipped: 'متخطاة',
      quarantined: 'لم تُستورد',
      failed: 'فشلت',
      pending: 'لم يُوصل إليها',
      rolledBack: 'حُذفت',
    },
    missingFromExport:
      'يذكرها ملف التصدير لكنها ليست فيه: {{messages}} رسالة و{{conversations}} محادثة.',
    checks: {
      title: 'الفحوص',
      passed: 'نجح',
      failed: 'فشل',
      codes: {
        all_accounted: 'استُورد كل سجل أو له سبب',
        no_failures: 'لم يفشل استيراد أي سجل',
        export_complete: 'كان ملف التصدير كاملًا',
        no_duplicates: 'لم يُستورد شيء مرتين',
        private_kept_private: 'بقيت الملاحظات الداخلية خاصة',
        nothing_sent: 'لم يُرسل شيء إلى العملاء',
        sample_matches: 'المحادثات النموذجية تطابق ملف التصدير',
        nothing_left: 'حُذف كل ما أنشأه الاستيراد',
      },
    },
    reasons: { title: 'لماذا لم تُستورد بعض السجلات', none: 'استُورد كل سجل.' },
    unsupported: {
      title: 'حقول لم تُستورد',
      none: 'استُورد كل حقل.',
      count: '{{count}} سجل',
    },
    quarantine: {
      title: 'سجلات لم تُستورد',
      description: 'كلٌّ منها مع سببه. نزّل القائمة الكاملة كجدول بيانات.',
      none: 'لم يُستبعد أي سجل.',
      columns: {
        kind: 'النوع',
        id: 'المعرّف في التصدير',
        conversation: 'المحادثة',
        reason: 'السبب',
      },
      more: 'عرض المزيد',
      loading: 'جارٍ تحميل السجلات',
    },
    samples: {
      title: 'مقارنة العينات',
      description: 'محادثات قُرئت من Chatwoot، بجانب ملف التصدير.',
    },
    cutover: {
      title: 'الموافقة على الاستيراد',
      description: 'تحقّق من هذه قبل أن تتوقف عن استخدام الأداة القديمة.',
      checklist: {
        counts: 'الأعداد تطابق ما توقعته.',
        samples: 'المحادثات النموذجية تبدو صحيحة.',
        live: 'المحادثات الجديدة تصل الآن عبر Hamnivo، فلا يُستورد شيء مرتين.',
      },
      acknowledge: 'أقبل الفحوص الفاشلة المذكورة أعلاه.',
      acknowledgeRequired: 'أكّد أنك تقبل الفحوص الفاشلة.',
      approve: 'الموافقة على الاستيراد',
      approved: 'تمت الموافقة على الاستيراد.',
      rollbackWindow: 'حتى توافق، يمكنك حذف كل ما أنشأه هذا الاستيراد.',
    },
    rollback: {
      action: 'حذف المحادثات المستوردة',
      title: 'حذف ما أنشأه هذا الاستيراد؟',
      body: 'تُحذف من Chatwoot المحادثات والأشخاص الذين أنشأهم هذا الاستيراد. تبقى المحادثات الحية والأشخاص المستخدمون في مكان آخر.',
      submit: 'حذف',
      started: 'جارٍ حذف المحادثات المستوردة.',
      done: 'حُذفت {{conversations}} محادثة و{{contacts}} شخص.',
      kept: 'أُبقي على {{count}} سجل لأنها ما زالت مستخدمة.',
    },
  },
  export: {
    title: 'تصدير السجل',
    description: 'نزّل محادثات علامة تجارية كحزمة Hamnivo: الصيغة نفسها التي يستخدمها الاستيراد.',
    brand: 'العلامة التجارية',
    submit: 'تصدير',
    queued: 'بدأ التصدير. يظهر في القائمة عندما يصبح جاهزًا.',
    running: 'جارٍ تجهيز الحزمة…',
    ready: 'الحزمة جاهزة',
    download: 'تنزيل الحزمة',
    expired: 'حُذفت الحزمة بعد 24 ساعة. صدّر مرة أخرى.',
    failed: 'فشل التصدير. حاول مرة أخرى.',
  },
};
